import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { WrongLinkComponent } from './components/sign-up/wrong-link/wrong-link.component';
import { LoginComponent } from './components/parent/login/login.component';
import { CampListComponent } from './components/sign-up/camp-list/camp-list.component';
import { RegisterExistingUserComponent } from './components/sign-up/register-existing-user/register-existing-user.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AuthGuard } from './shared/guard/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'sign-in', component: SignInComponent },
  { path: 'register-user', component: CampListComponent },
  { path: 'register-user/wrong-link', component: WrongLinkComponent },
  { path: 'register-user/:campId', component: SignUpComponent },
  {
    path: 'register-existing-user/:campId',
    component: RegisterExistingUserComponent,
  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },

  {
    path: 'parent/login',
    component: LoginComponent,
  },
  {
    path: 'parent',
    redirectTo: 'participant',
  },
  {
    path: 'participant',
    loadChildren: () =>
      import('./components/participant/participant.module').then(
        (m) => m.ParticipantModule
      ),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/admin/admin.module').then((m) => m.AdminModule),
  },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verify-email-address', component: VerifyEmailComponent },
  {
    path: 'print',
    loadChildren: () =>
      import('./components/print/print.module').then((m) => m.PrintModule),
    outlet: 'print',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
